import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  apiUrl: 'https://restaurant-dev-api.optwaves.com/api',
  appName: 'Optwaves Restaurant',
  version: '1.0.0',
  defaultLanguage: 'en',
  supportedLanguages: ['en', 'si', 'ta'],
  currency: {
    code: 'LKR',
    symbol: 'Rs.',
    decimal: 2,
  },
  features: {
    offlineMode: true,
    multiLanguage: true,
    hardwareIntegration: true,
    analytics: true,
  },
  stripe: {
    publicKey: 'pk_test_your_stripe_public_key',
  },
  reverb: {
    key: 'restaurantkdslocalkey',
    host: '127.0.0.1',
    port: 8080,
    scheme: 'http',
  },
  googleClientId:
    '34196693129-hmg7ed2ngn9ml4ui4ega7dbkuhvcmt4g.apps.googleusercontent.com',
  googleClientScriptUrl: 'https://accounts.google.com/gsi/client',
  googleClientScriptFallback: '/assets/google/gsi-client.js',
};

